import type { AppSettingsState } from '../../types/redux';

export const SET_APP_LOGO = 'SET_APP_LOGO' as const;
export const SET_FOOTER_NAVIGATE = 'SET_FOOTER_NAVIGATE' as const;
export const SET_IDENTIFICATION_METHODS = 'SET_IDENTIFICATION_METHODS' as const;
export const SET_ACCESS_LEVEL = 'SET_ACCESS_LEVEL' as const;
export const SET_APP_DATA = 'SET_APP_DATA' as const;

export const setAppLogo = (appLogo: string) => ({
    type: SET_APP_LOGO,
    payload: appLogo
});

export const setFooterNavigate = (isVisible: boolean) => ({
    type: SET_FOOTER_NAVIGATE,
    payload: isVisible
});

export const setIdentificationMethods = (methods: string[]) => ({
    type: SET_IDENTIFICATION_METHODS,
    payload: methods
});

export const setAccessLevel = (accessLevel: AppSettingsState['accessLevel']) => ({
    type: SET_ACCESS_LEVEL,
    payload: accessLevel
});

export const setAppData = (appData: Record<string, any>) => ({
    type: SET_APP_DATA,
    payload: appData
});

export type AppSettingsAction =
    | ReturnType<typeof setAppLogo>
    | ReturnType<typeof setFooterNavigate>
    | ReturnType<typeof setIdentificationMethods>
    | ReturnType<typeof setAccessLevel>
    | ReturnType<typeof setAppData>;
